module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/holes/window/window.obj";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/holes/window/window.obj
// module id = 505
// module chunks = 0